import { STATUS_COLORS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export default function StatusBadge({ status, size = "default", className }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.Pending;
  const padding = size === "sm" ? "px-2 py-0.5" : "px-3 py-1";
  return (
    <span
      data-testid={`status-badge-${(status || "pending").toLowerCase().replace(" ", "-")}`}
      className={cn(
        "inline-flex items-center gap-2 border text-[10px] subtitle uppercase tracking-[0.2em]",
        c.bg,
        c.text,
        c.border,
        padding,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5", c.dot)} />
      {status}
    </span>
  );
}
